import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Select from "react-select";
import ListService from "../../../Services/Shared/List.service";
import { reactSelectStyles } from "../../../../util/reactSelectUtils";
const initDropdownsData = (data, populationOnly) => {
    const result = {};
    if (!data) {
        return result;
    }
    const populationsArray = data.map((row) => {
        return { id: row.populationId, name: row.populationName };
    });
    result.populations = ListService.unique(populationsArray, (i) => i.id);
    if (!populationOnly) {
        const studentTypesArray = data.map((row) => {
            return { id: row.studentTypeId, name: row.studentType };
        });
        result.studentTypes = ListService.unique(studentTypesArray, (i) => i.id);
        const termTypesArray = data.map((row) => {
            return { id: row.cohortType, name: row.cohortType };
        });
        result.termTypes = ListService.unique(termTypesArray, (i) => i.id);
    }
    return result;
};
const StudentMetricsSelector = (props) => {
    var _a, _b, _c;
    const dropdowns = initDropdownsData(props.chartState.data, props.populationOnly);
    return (_jsxs("div", { className: "row", children: [_jsx("div", { className: "form-group col-12 col-md-4", children: _jsx(Select, { "aria-label": "Populations", styles: reactSelectStyles, isLoading: props.chartState.isLoading, onChange: (item) => {
                        if (item) {
                            props.setAttributes((prevAtts) => {
                                return Object.assign(Object.assign({}, prevAtts), { populationType: {
                                        id: item.value,
                                        name: item.label,
                                    } });
                            });
                        }
                    }, value: {
                        value: props.attributes.populationType.id,
                        label: props.attributes.populationType.name,
                    }, options: (_a = dropdowns.populations) === null || _a === void 0 ? void 0 : _a.map((pop) => ({
                        label: pop.name,
                        value: pop.id,
                    })), isClearable: false }) }), !props.populationOnly && (_jsxs(_Fragment, { children: [_jsx("div", { className: "form-group col-12 col-md-4", children: _jsx(Select, { "aria-label": "Student Type", styles: reactSelectStyles, isLoading: props.chartState.isLoading, onChange: (item) => {
                                if (item) {
                                    props.setAttributes((prevAtts) => {
                                        return Object.assign(Object.assign({}, prevAtts), { studentType: {
                                                id: item.value,
                                                name: item.label,
                                            } });
                                    });
                                }
                            }, options: (_b = dropdowns.studentTypes) === null || _b === void 0 ? void 0 : _b.map((type) => ({
                                label: type.name,
                                value: type.id,
                            })), value: {
                                value: props.attributes.studentType.id,
                                label: props.attributes.studentType.name,
                            }, isClearable: false }) }), _jsx("div", { className: "form-group col-12 col-md-4", children: _jsx(Select, { "aria-label": "Term", styles: reactSelectStyles, isLoading: props.chartState.isLoading, onChange: (item) => {
                                if (item) {
                                    props.setAttributes((prevAtts) => {
                                        return Object.assign(Object.assign({}, prevAtts), { termType: {
                                                id: item.value,
                                                name: item.label,
                                            } });
                                    });
                                }
                            }, options: (_c = dropdowns.termTypes) === null || _c === void 0 ? void 0 : _c.map((termType) => ({
                                label: termType.name,
                                value: termType.id,
                            })), value: {
                                value: props.attributes.termType.id,
                                label: props.attributes.termType.name ||
                                    props.attributes.termType.id,
                            }, isClearable: false }) })] }))] }));
};
export default StudentMetricsSelector;
